import { render, staticRenderFns } from "./Image-Gallery.vue?vue&type=template&id=ab286f0a&"
import script from "./Image-Gallery.vue?vue&type=script&lang=js&"
export * from "./Image-Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Image-Gallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports